import { useQuery } from 'react-query';
import { ApiProposalRepository } from 'services/proposal/repositories/implementations/ApiProposalRepository';
import { QueryKeys } from 'utils/queryKeys';

export const useAccountUsersQuery = () => {
  return useQuery(QueryKeys.accountUsers, ApiProposalRepository.getAccountUsers);
};
